import m from 'mithril';
import dayjs from 'dayjs';
import './Calendar.scss';
import { SingleMonthView } from './SingleMonthView';

interface Attrs {
    startYear:number, 
    startMonth:number, 
    numberOfMonths:number,
    selectionStartDate?: string|null,
    selectionEndDate?: string|null,
    minDate?:string,
    maxRange: number,
    isOnDesktop?: boolean,
    onDateClicked: (date:string) => void;
}

interface YearMonth {
    year:number;
    month:number;
}

export function MultipleMonthView() : m.Component<Attrs> {
    
    let buildYearMonthArray = function(startYear:number, startMonth:number, numberOfMonths:number): YearMonth[] {
        let startMonthIndex = startMonth - 1; // make starting index 0
        return Array(numberOfMonths).fill(0).map((_, i)=> {
                return {
                    year: Math.trunc(startYear + ((startMonthIndex + i)/12)), // year needs increment if month is over 12
                    //year: startYear,
                    month: 1 + ((startMonthIndex + i) % 12) // start over again after 12 and convert back to starting index 1
                }
            });
    }

    let yearMonthArray:YearMonth[] = [];
    
    return {    
        oncreate(vnode) {
            if(vnode.attrs.selectionStartDate) {
                let year = dayjs(vnode.attrs.selectionStartDate).year();
                let month = dayjs(vnode.attrs.selectionStartDate).month();
                let elem = document.getElementById("year-month-" + year + "-" + (month + 1));
                if(elem) {
                    //elem.scroll();
                     window.scrollTo({
                        top: elem.getBoundingClientRect().y + window.scrollY,
                        behavior: 'smooth',
                    });
                }
            }            
        },
        
        oninit(vnode) {           

            yearMonthArray = buildYearMonthArray(
                vnode.attrs.startYear, vnode.attrs.startMonth, vnode.attrs.numberOfMonths);

            console.log(yearMonthArray)    
        },

        view(vnode) {  
            const { selectionStartDate, selectionEndDate, minDate, maxRange, isOnDesktop, onDateClicked} = vnode.attrs;

            return yearMonthArray.map(yearMonth => 
                m(SingleMonthView, {
                    year : yearMonth.year,
                    month : yearMonth.month,
                    titleVisible: true,
                    exclusive: true,
                    selectionStartDate: selectionStartDate,
                    selectionEndDate: selectionEndDate,
                    minDate: minDate,
                    maxRange: maxRange,                    
                    isOnDesktop: isOnDesktop,
                    onDateClicked : (date:string) => {
                        onDateClicked(date);
                    }
                })
            )
        }
    }
}